import { CommentLink } from './comment-link'
import { CommentMention } from './comment-mention'
import { EditorLink } from './editor-link'
import { EditorMention } from './editor-mention'
import { EditorMentionSuggestions } from './editor-mention-suggestions'

export const EDITOR_COMPONENTS = {
  Mention: EditorMention,
  MentionSuggestions: EditorMentionSuggestions,
  Link: EditorLink,
}

export const COMMENT_BODY_COMPONENTS = {
  Mention: CommentMention,
  Link: CommentLink,
}

export const commentAnchorId = (commentId: string) => `comment-${commentId}`

export const COMMENT_MAX_LENGTH = 2000

export const MAX_NAMED_REACTORS = 3

// Distinguishes the surfaces that share the assessment.comment.* event names.
export const COMMENT_EVENT_SOURCES = {
  ASSESSMENT_PANEL: 'assessment_panel',
  CONTROL_TIMELINE: 'control_timeline',
  VENDOR_PORTAL: 'vendor_portal',
} as const

export const FETCH_MORE_RETRY_DELAYS_MS = [1000, 2000, 4000]
